import { withQuery } from './lib/withQuery'

export const addSourceToAudioUrl = (id: string) => withQuery('audio/source', { id })

export const deleteSourceUrl = (id: string) => withQuery('source', { id })

export const getSourceTranscodingsUrl = (id: string) =>
    withQuery('source/transcodings', { sourceId: id })
